/**
 * Formats structured address fields into a readable Hebrew string.
 * Accepts any object with optional fields: street, street_number, apartment, floor, postal_code, city
 */

export function formatAddress(c = {}) {
  if (!c) return '';
  const parts = [];
  if (c.street) {
    let line = c.street;
    if (c.street_number) line += ` ${c.street_number}`;
    if (c.apartment) line += ` דירה ${c.apartment}`;
    if (c.floor) line += ` קומה ${c.floor}`;
    parts.push(line);
  }
  if (c.postal_code) parts.push(c.postal_code);
  return parts.join(', ');
}

export function formatFullAddress(c = {}) {
  if (!c) return '';
  return [c.city, formatAddress(c)].filter(Boolean).join(', ');
}
